import { apiClient } from './ApiClient';
import { buildQueryString } from '../utils/QueryStringBuilder';

export type DeviceDeploymentInfo = {
  deployments: any[];
  canopyDeviceId: string;
  lifecycleState: string;
  batteryLevel: number;
  lastConnected: string;
  vehicle: {
    isInMotion: boolean;
    updatedAt: string;
  };
  pendingOta: {
    version: string;
    status: string;
  };
  deviceReportedVersion: string;
};

type DeviceTag = {
  tagId?: string;
  tagName?: string;
  canopyDeviceId?: string;
  serialNumber?: string;
};
export type DeviceTagResponse = {
  results: DeviceTag[];
  count: number;
  next: string;
};
export type DeployToDeviceInput = {
  serialNumber: string;
  deploymentId: string;
  canopyDeviceId: string;
};
type DeviceDeploymentState = {
  status: string;
  updatedAt: string;
};
type DeviceDeployment = {
  id: string;
  canopyDeviceId: string;
  serialNumber: string;
  deploymentId: string;
  states: {
    download: DeviceDeploymentState[];
    install: DeviceDeploymentState[];
  };
  status: string;
  downloadStatus: string;
  installStatus: string;
  createdAt: string;
  updatedAt: string;
};
type GetDeviceTagsQueryParams = {
  serialNumber?: string;
  limit?: number;
  tagId?: string;
  nextToken?: string;
};

export const getDeploymentInfoForDevice = async (
  serialNumber: string,
): Promise<DeviceDeploymentInfo> => {
  const response = await apiClient
    .getClient()
    .get(`device/${serialNumber}/deployments/info`);
  return response.data;
};

export const getDeviceTags = async (params: {
  limit?: number;
  serialNumber?: string;
  tagId?: string | undefined;
  nextToken?: string;
}): Promise<DeviceTagResponse> => {
  const queryString = buildQueryString<GetDeviceTagsQueryParams>(params);
  const response = await apiClient.getClient().get(`device/tags${queryString}`);
  return response.data;
};

export const deployToDevice = async (
  input: DeployToDeviceInput,
): Promise<string> => {
  const response = await apiClient.getClient().post(`device/deploy`, input);
  return response.data;
};

export const getDeviceDeployments = async (
  deploymentId: string,
): Promise<DeviceDeployment[]> => {
  const response = await apiClient
    .getClient()
    .get(`device/deployments/${deploymentId}`);
  return response.data;
};

export const sendStartInstallToDevice = async (params: {
  canopyDeviceId: string;
  jobId: string;
}): Promise<string> => {
  const response = await apiClient.getClient().post(`device/install`, params);
  return response.data;
};
